import { useRoute} from '@react-navigation/native';
import React from 'react';
import {BackHandler, Linking, LogBox} from 'react-native';
import {useTheme} from 'styled-components/native';
import {Button} from '../../components/Interface/Forms/Buttons/Button';

import {
  Container,
  Header,
  CloseButton,
  CloseButtonIcon,
  Content,
  IconContainer,
  Icon,
  Title,
  Text,
  Footer,
  LinkButtonContainer,
  SupportContactList,
  SupportContactItem,
  SupportContactIcon,
  SupportContactText,
} from './styles';
import {LinkButton} from '../../components/Interface/Forms/Buttons/LinkButton';
import {SafeAreaView} from 'react-native-safe-area-context';

interface Params {
  type: 'error' | 'success' | 'warning' | 'pending';
  closeIconAction: () => void;
  title: string;
  text: string;
  buttonText: string;
  icon?: string;
  buttonAction: () => void;
  secondButtonText?: string;
  secondButtonAction?: () => void;
  showSupport?: boolean;
}

LogBox.ignoreLogs([
  'Non-serializable values were found in the navigation state',
]);

type ConfirmationScreenProps = Partial<Params>;

export function ConfirmationScreen(props: ConfirmationScreenProps) {
  const theme = useTheme();
  const route = useRoute();


  const routeParams = route.params as Params | undefined;
  const mergedParams = {...routeParams, ...props} as Params;

  const {
    type,
    icon,
    closeIconAction,
    title,
    text,
    buttonText,
    buttonAction,
    secondButtonText,
    secondButtonAction,
  } = mergedParams;

  if (
    !type ||
    !title ||
    !text ||
    !buttonText ||
    !closeIconAction ||
    !buttonAction
  ) {
    return null;
  }

  BackHandler.addEventListener('hardwareBackPress', function () {
    return true;
  });

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
      <Container>
        <Header
          style={{
            backgroundColor:
              type === 'error'
                ? theme.colors.red
                : type === 'success'
                ? theme.colors.green_light

                : theme.colors.yellow,
          }}>
          <CloseButton activeOpacity={1} onPress={closeIconAction}>
            <CloseButtonIcon name="x" />
          </CloseButton>
        </Header>
        <Content>
          <IconContainer
            style={{
              shadowColor: theme.colors.text_dark,
              shadowOffset: {width: 0, height: 7},
              shadowOpacity: 0.2,
              shadowRadius: 6,
              elevation: 8,
            }}>
            <Icon
              name={
                icon
                  ? icon
                  : type === 'error'
                  ? 'x-circle'
                  : type === 'success'
                  ? 'check-circle'
                  : type === 'pending'
                  ? 'clock'
                  : 'alert-triangle'
              }
              style={{
                color:
                  type === 'error'
                    ? theme.colors.red
                    : type === 'success'
                    ? theme.colors.primary

                    : theme.colors.yellow,
              }}
            />
          </IconContainer>
          <Title>{title}</Title>
          <Text>{text}</Text>
          {secondButtonText && secondButtonAction ? (
            <LinkButtonContainer>
              <LinkButton
                action={secondButtonAction}
                enabled
                text={secondButtonText}
              />
            </LinkButtonContainer>
          ) : null}
        </Content>
        <Footer>
          <SupportContactList>
            <SupportContactItem>
              <SupportContactIcon name="mail" />
              <SupportContactText>
                atendimento@barataocombustiveis.com.br
              </SupportContactText>
            </SupportContactItem>
            <SupportContactItem>
              <SupportContactIcon name="phone" />
              <SupportContactText>(61) 99820-2004</SupportContactText>
            </SupportContactItem>
          </SupportContactList>
          <Button title={buttonText} enabled onPress={buttonAction} />
          {(type === 'error' || mergedParams.showSupport) && (
            <LinkButtonContainer>
              <LinkButton
                action={() =>
                  Linking.openURL(
                    'https://wa.me/5561998202004?text=Ol%C3%A1%2C+preciso+de+ajuda%21',
                  )
                }
                enabled
                text="Falar com suporte"
              />
            </LinkButtonContainer>
          )}
        </Footer>
      </Container>
    </SafeAreaView>
  );
}
